
import _ from 'lodash';
import {setDefaults} from "@/router/helper";


// 工厂生产
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const fabricTailoringSendOut= () => import('@/views/factoryProduction/fabricTailoringSendOut.vue');
const orderCuttingProcess= () => import('@/views/factoryProduction/orderCuttingProcess.vue');
const orderCuttingContain= () => import('@/views/factoryProduction/orderCuttingContain.vue');
const cuttingTableRecordDetail= () => import('@/views/factoryProduction/cuttingTableRecordDetail.vue');
const cuttingTableRecordDetailSimple= () => import('@/views/factoryProduction/cuttingTableRecordDetailSimple.vue');
const orderMainContainTags= () => import('@/views/factoryProduction/orderMainContainTags.vue');
//这是打样，订单里的打样信息，和打样中心的打样。在内容上相近，

const routes = [
  {
    path:'orderMainContainTags/:orderId',
    meta:{
      title:'订单全进展'
    },
    component:orderMainContainTags
  },
  {
    path: 'orderCuttingProcess',
    meta: {
      title: '裁剪进度',
    },
    component: orderCuttingProcess,
  },
  {
    path: 'orderCuttingContain/:orderId',
    meta: {
      title: '裁剪详情',
    },
    component: orderCuttingContain,
  },{
    path: 'cuttingTableRecord/:recordId',
    meta: {
      title: '裁床详情[旧]',
    },
    component: cuttingTableRecordDetail,
  },
  {
    path: 'cuttingTableRecordDetail/:recordId',
    meta: {
      title: '裁床详情',
    },
    component: cuttingTableRecordDetailSimple,
  },
  {
    // 单材料的床领料情况
    path:'fabricTailoringSendOut/:stuffId',
    meta: {
      title: '裁剪领料',
    },
    name:'fabricTailoringSendOut',
    component:fabricTailoringSendOut,
  }
];



export default setDefaults(routes);
